/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createPi } from '../../factoriesAny.js';
export var piDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createPi: createPi
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPi.generated.js
// module id = 643
// module chunks = 0